import 'aws-amplify/auth/enable-oauth-listener';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import Theme from '@amzn/meridian/theme';

import App from 'src/components/App';
import { AuthProvider } from 'src/auth/AuthProvider';
import { buildCognitoConfig, loadRuntimeConfig } from 'src/auth/cognito-config';

import '@amzn/meridian-tokens/base/font/amazon-ember.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}
const root = createRoot(container);

// Fetch the deploy-time runtime config, configure Amplify, then render. The
// `enable-oauth-listener` import above completes the OAuth redirect on return.
loadRuntimeConfig()
  .then((config) => {
    Amplify.configure(buildCognitoConfig(config));
    root.render(
      <StrictMode>
        <Theme>
          <AuthProvider>
            <App />
          </AuthProvider>
        </Theme>
      </StrictMode>,
    );
  })
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.error('Failed to load runtime config', error);
    root.render(
      <StrictMode>
        <Theme>
          <div style={{ padding: 24 }}>Failed to load application configuration.</div>
        </Theme>
      </StrictMode>,
    );
  });
